import React from 'react'
import { compose } from 'recompose'
import classnames from 'classnames'
import { Input } from 'semantic-ui-react'

const TextInput = (props) => {
  const { label, dummy, placeHolder, input, require, editable, filterKey, style, meta: { touched, error } } = props
  const activeClass = classnames({error: (touched && error)})

  if (filterKey && input.value && input.value === filterKey) {
    input.value = '-'
  }

  return (
    <div className='fieldRow' style={{...style}}>
      <span className='fieldLabel' name={input.name}>
        {label}
        {require ? <span className='require'>*</span> : null}
        {touched && error ? <span className='error'>{error}</span> : null}
      </span>
      <div className={`fieldInput ${editable!==false?'editableTextInput':''}`} style={dummy?{visibility:'hidden',maxHeight:0}:{}}>
        
      </div>
    </div>
  )
}

export default compose()(TextInput)